<div class="whos-participating">
  <h1 class="whos-participating-title">
    Who is this membership for?
  </h1>

  <div role="content" class="whos-participating-content">
    <div *ngIf="!ready">
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
    <section class="whos-participating-buttons" *ngIf="ready">
      <button (click)="submitter.myChild()">
        <se-po-highlight-label
          theme="child"
          label="My Child"></se-po-highlight-label>
      </button>

      <button (click)="submitter.myself()">
        <se-po-highlight-label
          theme="adult"
          label="Myself"></se-po-highlight-label>
      </button>
    </section>
  </div>
</div>
